<div class="container">
    <h1>App Information</h1>
    @if (!appBootstrapped) {
        <h3>
            Webapp bootstrap
            <app-loader [isOverlay]="false" size="button" />
        </h3>
    }
    @if (appBootstrapped) {
        <div class="row">
            @for (microservice of microServiceList; track $index) {
                <div class="col-lg-12">
                    <label>
                        {{ microservice }}:
                        @if (appVersions[microservice]) {
                            <span style="font-weight: 900">{{ appVersions[microservice] }}</span>
                        } @else {
                            <app-loader [isOverlay]="false" size="button" />
                        }
                    </label>
                </div>
            }
            <div class="col-lg-12">
                <label
                    >Help:
                    <span style="font-weight: 900">{{ helpVersion }}</span>
                </label>
            </div>
        </div>
    }
</div>

<div class="container">
    <h1>Sentry Test</h1>
    <div class="row">
        <div class="col-lg-12">
            <button (click)="testSentryIntegration()">Test Integration</button>
        </div>
    </div>
</div>
